import { render, staticRenderFns } from "./PayrollScrollHeader.vue?vue&type=template&id=da196790&scoped=true&"
import script from "./PayrollScrollHeader.vue?vue&type=script&lang=js&"
export * from "./PayrollScrollHeader.vue?vue&type=script&lang=js&"
import style0 from "./PayrollScrollHeader.vue?vue&type=style&index=0&id=da196790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da196790",
  null
  
)

export default component.exports